const UID_FIELD_NAME = {
  dev: "uid.dev",
  fat: "uid.fat",
  stage: "uid.stage",
  prod: "uid",
};

const env = process.env.NEXT_PUBLIC_DEPLOY_ENV || "prod";

export const uidFieldName = UID_FIELD_NAME[env];

export const tokenFieldName = `token.${env}`;
